import React from 'react';

const PageTitle = ({ title, description }) => {
  return (
    <div className="page-title mb-8">
      <h1 className="text-2xl font-semibold text-foreground pb-1">
        {title}
      </h1>
      <p className="text-foreground font-sm">
        {description}
      </p>
    </div>
  );
};

export default PageTitle;
